import React from 'react';
import { SUBTLE, MUTED } from './tokens';
import { useSoft, SOFT } from './SurfaceStyleContext';

/** Dashed empty state: `NOTHING HERE YET.` + a line + an optional action. */
export default function EmptyBox({ title = 'NOTHING HERE YET.', children, action, mobile = false, className = '', testId = 'empty-box' }) {
  const soft = useSoft();
  if (soft) {
    // Soft: a white panel — bold title line, a muted sentence, the action as a pill.
    return (
      <div className={`flex flex-col items-start bg-white ${className}`} style={{ gap: 8, padding: mobile ? '18px 16px' : 26 }} data-testid={testId} data-soft="1">
        <span className="font-mono font-bold uppercase" style={{ fontSize: mobile ? 11 : 12, letterSpacing: '0.16em' }}>{title}</span>
        {children && <p className="font-mono" style={{ fontSize: 12, color: SOFT.muted, maxWidth: 420, lineHeight: 1.6, margin: 0 }}>{children}</p>}
        {action && <div style={{ marginTop: 4 }}>{action}</div>}
      </div>
    );
  }
  return (
    <div className={`flex flex-col items-center gap-[10px] bg-white text-center ${className}`} style={{ border: `2px dashed ${SUBTLE}`, padding: mobile ? '32px 16px' : '56px 32px' }} data-testid={testId}>
      <span className="font-mono font-bold uppercase" style={{ fontSize: mobile ? 12 : 13, letterSpacing: mobile ? '0.15em' : '0.2em', color: SUBTLE }}>{title}</span>
      {children && <p className="font-mono" style={{ fontSize: mobile ? 12 : 13, color: MUTED, maxWidth: 360, lineHeight: 1.6, margin: 0 }}>{children}</p>}
      {action}
    </div>
  );
}
